import ReportTable from '../../../../../components/Grid/ReportTable';

export default function ProdutosTableAgrupada(props: any) {
  return <ReportTable model={props.model} columnCount={4} />;
}
